const ReferralsActionTypes = {
    START_GET_REFERRALS: 'START_GET_REFERRALS',
    SUCCESS_GET_REFERRALS: 'SUCCESS_GET_REFERRALS',
    FINISH_GET_REFERRALS: 'FINISH_GET_REFERRALS',
    FAILURE_GET_REFERRALS: 'FAILURE_GET_REFERRALS',

    START_GET_REFERRALS_STATUS: 'START_GET_REFERRALS_STATUS',
    SUCCESS_GET_REFERRALS_STATUS: 'SUCCESS_GET_REFERRALS_STATUS',
    FINISH_GET_REFERRALS_STATUS: 'FINISH_GET_REFERRALS_STATUS',
    FAILURE_GET_REFERRALS_STATUS: 'FAILURE_GET_REFERRALS_STATUS',

    START_POST_REFERRALS_TRAFFIC: 'START_POST_REFERRALS_TRAFFIC',
    SUCCESS_POST_REFERRALS_TRAFFIC: 'SUCCESS_POST_REFERRALS_TRAFFIC',
    FINISH_POST_REFERRALS_TRAFFIC: 'FINISH_POST_REFERRALS_TRAFFIC',
    FAILURE_POST_REFERRALS_TRAFFIC: 'FAILURE_POST_REFERRALS_TRAFFIC',
}

export default ReferralsActionTypes
